import { useMutation } from 'react-query'
import { createWaitlist, CreateWaitlistBodyParams } from './createWaitlist'
import { useSentry } from 'banquet-runtime-modules'
import { getRecaptchaToken } from '@local/recaptcha'
import { GOOGLE_RECAPTCHA_KEY } from '../recaptcha/constants'

export type CreateWaitlistMutationParams = CreateWaitlistBodyParams

export const useCreateWaitlist = (recaptchaEnabled: boolean) => {
  const sentry = useSentry()

  return useMutation(
    async ({
      restaurantGuid,
      params
    }: {
      restaurantGuid: string
      params: CreateWaitlistMutationParams
    }) => {
      let token: string | undefined = undefined

      let recaptchaDuration: number | undefined
      if (recaptchaEnabled) {
        const recaptchaStart = new Date()
        try {
          token = await getRecaptchaToken(
            GOOGLE_RECAPTCHA_KEY,
            'create_waitlist_submit'
          )
        } catch (e) {
          sentry.captureException(e as Error, {
            captureContext: {
              extra: {
                restaurantGuid
              }
            }
          })
          // Do not re-throw; just pass no token instead in case we've turned it off
        }
        const recaptchaEnd = new Date()
        recaptchaDuration =
          recaptchaEnd.getMilliseconds() - recaptchaStart.getMilliseconds()
        sentry.captureMessage('reCAPTCHA token success', 'info', {
          captureContext: {
            extra: {
              recaptchaDuration
            }
          }
        })
      }

      return createWaitlist(restaurantGuid, {
        ...params,
        recaptchaToken: token
      })
    }
  )
}
